import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Account() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  if (!loading && !user) { nav("/login"); return null; }
  if (!user) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("New passwords don't match"); return;
    }
    if (form.new_password.length < 6) {
      toast.error("New password must be at least 6 characters"); return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password updated");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to update");
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="max-w-xl mx-auto px-6 py-12">
        <div className="mono text-xs uppercase tracking-[0.3em] text-[#C77E3C]">/ Account</div>
        <h1 className="heading text-4xl md:text-5xl font-black uppercase tracking-tight mt-2">Account settings</h1>

        <div className="mt-8 brut-border bg-white p-6">
          <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#555]">Signed in as</div>
          <div className="heading text-xl font-bold mt-1">{user.name}</div>
          <div className="text-sm text-[#555]">{user.email} · <span className="uppercase">{user.role}</span></div>
        </div>

        <div className="mt-6 brut-border bg-white p-6">
          <h2 className="heading text-2xl font-bold uppercase">Change password</h2>
          <p className="text-sm text-[#555] mt-1">For accounts created with email + password.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="mono text-xs uppercase tracking-[0.2em] font-bold">Current password</label>
              <input data-testid="cp-current" required type="password" value={form.current_password}
                onChange={(e) => setForm({ ...form, current_password: e.target.value })}
                className="w-full mt-2 brut-border bg-white px-4 py-3" />
            </div>
            <div>
              <label className="mono text-xs uppercase tracking-[0.2em] font-bold">New password</label>
              <input data-testid="cp-new" required type="password" minLength={6} value={form.new_password}
                onChange={(e) => setForm({ ...form, new_password: e.target.value })}
                className="w-full mt-2 brut-border bg-white px-4 py-3" />
            </div>
            <div>
              <label className="mono text-xs uppercase tracking-[0.2em] font-bold">Confirm new password</label>
              <input data-testid="cp-confirm" required type="password" value={form.confirm}
                onChange={(e) => setForm({ ...form, confirm: e.target.value })}
                className="w-full mt-2 brut-border bg-white px-4 py-3" />
            </div>
            <button data-testid="cp-submit" disabled={busy} className="btn-primary">
              {busy ? "Updating…" : "Update password"}
            </button>
          </form>
        </div>
      </section>
    </Layout>
  );
}
